import { useQuery } from '@tanstack/react-query';
import { fetchRegistryProducts } from '@/services/productRegistryService';
import type { ProductRegistryQueryParams } from '@/types/productRegistry';

export function useProductRegistry(params: ProductRegistryQueryParams) {
  return useQuery({
    queryKey: ['product-registry', params],
    queryFn: () => fetchRegistryProducts(params),
    placeholderData: (previous) => previous,
  });
}
